<script setup lang="ts">
type ActionSummaryCardField = {
    label: string;
    value: string;
};

defineProps<{
    summary?: string;
    detailRows?: string[];
    detailFields?: ActionSummaryCardField[];
}>();
</script>

<template>
    <div class="rounded-xl border border-border/70 bg-background/76 px-3 py-3">
        <p v-if="summary" class="text-sm leading-6 text-foreground">{{ summary }}</p>

        <div
            v-if="detailFields?.length"
            class="mt-3 grid gap-2 sm:grid-cols-2"
        >
            <div
                v-for="field in detailFields"
                :key="`${field.label}:${field.value}`"
                class="rounded-lg border border-border/60 bg-background/82 px-3 py-2"
            >
                <p class="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">
                    {{ field.label }}
                </p>
                <p class="mt-1 text-sm text-foreground">{{ field.value }}</p>
            </div>
        </div>

        <div v-if="detailRows?.length" class="mt-3 space-y-2">
            <p
                v-for="detail in detailRows"
                :key="detail"
                class="text-sm text-muted-foreground"
            >
                {{ detail }}
            </p>
        </div>
    </div>
</template>
